import { combineReducers } from 'redux';
import search from './search';
import header from './header';
import catalog from './catalog';
import featuredContent from './featuredContent';

export default combineReducers({
  search,
  header,
  catalog,
  featuredContent
});
